import {uploadImage} from "../mediaUploader";

export async function handleFormChoiceResource(params) {
  let data = params.data;
  if (params.data.image && params.data.image.rawFile instanceof File) {
    data.image = (await uploadImage(params.data.image, false, data.project))['@id'];
  }
  return data;
}
